import React, { Component } from "react";
import { connect } from "react-redux";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "state/actions/UiActions";
import { Utils } from "utils/Utils";


class RecurrenceChange extends Component {

  constructor(props) {
    super(props);

    console.log(props);


    this.state = {
      subscriberId: this.props.subscriberId,
      recurrenceState: props.recurrenceState,
      currentStep: 0,
      disableRecurrenceObs: "",
      recurrenceObsModalVisible: false
    }
  }


  toggleRecurrenceObsModal =() =>{
    this.setState({
      recurrenceObsModalVisible: !this.state.recurrenceObsModalVisible
    })
  }

  updateDisableRecurrenceObs=(event)=>{
    this.setState({
      disableRecurrenceObs: event.target.value
    })
  }
 
  disableRecurrence = () => {
    return(event)=>{
      event.preventDefault();
      let token = this.props.token.Authorization;
      let {person} = this.props;

      ExecuteRequest(
        GlamboxEndpoints.Subscriber.disableRecurrence,
        {
          subscriberId: this.state.subscriberId,
          isAdmin: false,
          username: person.firstName + " " + person.lastName,
          message: this.state.disableRecurrenceObs
        },
        "PUT",
        {
          Authorization: token
        },
        null,
        (response) => {
          const {
            result,
            statusCode
          } = response;

          if (statusCode === 200) {
            this.props.successAlert(
              (result && result.message)
                ? result.message
                : "Recorrência desabilitada com sucesso."
            );
            this.props.onFinish(false);
          } else {
            this.props.errorAlert(
              (result && result.message)
                ? result.message
                : "Erro ao desabilitar a recorrência."
            );
          }
        }
      );
    }    
  }

  reactivateRecurrence=()=>{
  
    return(event)=>{
      event.preventDefault();
      let token = this.props.token.Authorization;

      ExecuteRequest(
        GlamboxEndpoints.Subscriber.enableRecurrence,
        {
          subscriberId: this.state.subscriberId
        },
        "PUT",
        {
          Authorization: token
        },
        null,
        (response) => {
          const {
            result,
            statusCode
          } = response;

        if (statusCode === 200) {
          this.props.successAlert(
            (result && result.message) 
              ? result.message 
              : "Recorrência ativada com sucesso."
          );
          this.props.onFinish(true);
        } else {
          this.props.errorAlert(
            (result && result.message) 
              ? result.message 
              : "Não foi possível reativar sua recorrência."
          );
        }
      }
      );
    }    
  }
  
  renderDisableRecurrence(){
    const {recurrence} = this.props;

    if (!recurrence) return null;

    return(
      <div> 
        <h3 className={"text-center"}>Tem certeza de que deseja desativar a sua recorrência?</h3>
        <p className={"text-center"}>
          Lembre-se de que, se sua assinatura ficar inativa por mais de 30 dias, você perderá todos os Glampoints acumulados, deixará de fazer parte do maior clube de beleza do Brasil, além de deixar de receber na sua casa uma seleção de produtos exclusivos de acordo com seu perfil de beleza.
        </p>
        <p className={"text-center"}>
          <div className={"level-2 gp_alert_pis"} style={{ marginTop: "10px" }}>
            <div className={ "icon" }>
              <svg width="36" height="36" viewBox="0 0 36 36">
                <path d="M6.4,36V32.836a3.17,3.17,0,0,1,2.11-2.983V18a9.492,9.492,0,0,1,18.985,0V29.853a3.17,3.17,0,0,1,2.11,2.983V36Zm2.11-3.164V33.89H27.492V32.836a1.056,1.056,0,0,0-1.055-1.055H9.563A1.056,1.056,0,0,0,8.508,32.836ZM10.617,18V29.672H25.383V18a7.383,7.383,0,0,0-14.765,0Zm6.328,7.383v-2.11h2.11v2.11Zm0-4.218V14.836h2.11v6.329Zm14.765-2.11v-2.11H36v2.11ZM0,19.055v-2.11H4.289v2.11ZM4.576,6.068,6.068,4.576,9.05,7.559,7.559,9.051ZM26.95,7.559l2.983-2.984,1.491,1.492L28.441,9.05Zm-10-3.27V0h2.11V4.289Z" fill="#933ec5"/>
              </svg>
            </div>
            AVISO: desabilitando a recorrência automática, será necessário esperar um período de 6 meses contados de {Utils.tempConvertDate(recurrence.nextPaymentDate)} para voltar a ser assinante pelo plano Mensal. Mas os planos Semestral e Anual estarão disponíveis para assinatura antes deste período.
          </div>
        </p>
        <p className={"text-center"}>
        Caso venha a desabilitar a recorrência automática, poderá reabilitá-la até {Utils.tempConvertDate(recurrence.nextPaymentDate)}.
        </p>
        <p className={"text-center"}>
          Gostaria de prosseguir com a solicitação?
        </p>       

        <p className={"text-center"}>
          <button className={"btn btn-sm btn-light-pink"} onClick={this.updateCurrentStep()}>Sim, desativar</button>
          &nbsp;
          <button className={"btn btn-sm btn-light-lime"} onClick={this.cancelRecurrence}>Não, manter</button>
        </p>
      </div>
    );
  }  

  renderDisableRecurrenceObs=()=>{
    return(
      <div>
        <h3 className={"text-center"}>Tem certeza que deseja desativar a sua recorrência?</h3>
        <p className={"text-center"}>
        Ok! Você deixará de ser uma Glamgirl em {Utils.editionDateName(this.props.subscriberDetail.lastEdition)}. Caso mude de ideia, basta reativar sua assinatura aqui mesmo!
        </p>
        <p className={"text-center"}>
          Por que você gostaria de cancelar a recorrência?
        </p>
        <textarea className={"form-control mb-2"} onChange={this.updateDisableRecurrenceObs} value={this.state.disableRecurrenceObs}/>
        
        <p className={"text-center"}>
          <button className={"btn btn-sm btn-light-pink"} onClick={this.disableRecurrence()}>Confirmar</button>
          &nbsp;
          <button className={"btn btn-sm btn-light-lime"} onClick={this.cancelRecurrence}>Não, manter</button>
        </p>
      </div>
    );
  }

  renderReactivateRecurrence=()=>{
    return(
      <div>
        <h3 className={"text-center"}>Reativar Recorrência</h3>
        <p className={"text-center"}>Glamgirl, você deseja reativar a recorrência para essa assinatura?</p>
        <p className={"text-center"}>
          <button className={"btn btn-sm btn-light-pink"} onClick={this.cancelRecurrence}>Voltar</button>
          &nbsp;
          <button className={"btn btn-sm btn-light-lime"} onClick={this.reactivateRecurrence()}>Reativar</button>
        </p>
      </div>
    );
  }

  updateCurrentStep=()=>{
    return(event)=>{
      this.setState({
        currentStep: this.state.currentStep + 1
      })
    }  
  }

  cancelRecurrence=()=>{
    this.props.onFinish(this.props.recurrenceState);
  } 

  render() {
    if(this.state.currentStep === 1){
      return(
        <div>
          {this.renderDisableRecurrenceObs()}
        </div>        
      );
    }    
    if (!this.props.recurrenceState ) {
      return(
        <div>
           {this.renderReactivateRecurrence()}
        </div>        
      );
    }else{
      return(
        <div>  
          {this.renderDisableRecurrence()}
        </div>  
      );
    }
    
  }
}

const mapStateToProps = (state) => {
  return {
    person: state.person.data.person,
    token: state.token.data
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    }
    , errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    }
  }
}

RecurrenceChange = connect(mapStateToProps, mapDispatchToProps)(RecurrenceChange);

export { RecurrenceChange };